import React from 'react';
import { Link } from 'react-router-dom';
import { 
  RocketLaunchIcon, 
  BellIcon, 
  AdjustmentsHorizontalIcon, 
  ArrowRightIcon, 
  HeartIcon, 
  Squares2X2Icon 
} from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';

const ComingSoon = () => {
  const { user } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] bg-gradient-to-b from-white to-neutral-50 px-6 py-12 text-center">
      <div className="max-w-2xl">
        <h1 className="text-4xl font-bold text-primary mb-4 flex items-center justify-center">
          <AdjustmentsHorizontalIcon className="h-8 w-8 mr-3" />
          {user ? "Merci de votre confiance !" : "Bientôt disponible !"}
        </h1>
        
        <p className="text-lg text-neutral-700 mb-6">
          {user ? (
            <>
              Vous comptez beaucoup pour nous <HeartIcon className="inline-block h-5 w-5 text-red-500" /> Grâce à votre compte déjà actif, vous serez <span className="font-semibold">parmi les premiers informés</span> dès que notre <span className="font-semibold">algorithme d'estimation détaillée</span> sera prêt <span className="font-semibold">🎉</span>
            </>
          ) : (
            <>
              Nous peaufinons actuellement notre <span className="font-semibold">algorithme d'estimation détaillée</span> pour vous offrir les <span className="font-semibold">meilleurs résultats sur internet</span>.
            </>
          )}
        </p>
        
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg p-8 mb-8 shadow-lg transform hover:scale-[1.02] transition-all">
          <BellIcon className="h-8 w-8 mx-auto mb-4" />
          {user ? (
            <>
              <p className="text-md mb-6">
                En attendant, n'hésitez pas à explorer les autres fonctionnalités ou à mettre à jour vos informations si besoin. 🙌
              </p>
              <Link 
                to="/dashboard" 
                className="inline-flex items-center px-6 py-3 bg-white text-orange-600 font-medium text-lg rounded-md shadow-md hover:bg-orange-50 transition duration-200"
              >
                <Squares2X2Icon className="h-5 w-5 mr-2" />
                Retourner à mon tableau de bord
                <ArrowRightIcon className="h-5 w-5 ml-2" />
              </Link>
            </>
          ) : (
            <>
              <p className="text-md mb-6">
                Créez dès maintenant votre compte <span className="font-semibold">gratuit</span> pour être averti dès que cette fonctionnalité sera en ligne !
              </p>
              <Link 
                to="/register" 
                className="inline-flex items-center px-6 py-3 bg-white text-orange-600 font-medium text-lg rounded-md shadow-md hover:bg-orange-50 transition duration-200"
              >
                <RocketLaunchIcon className="h-5 w-5 mr-2" />
                Créer mon compte gratuitement
              </Link>
            </>
          )}
        </div>
        
        <p className="text-sm text-neutral-500">
          {user ? (
            "Nous vous tiendrons informé très bientôt ! 🚀"
          ) : (
            "On vous promet, ça arrive vite et ça va vous plaire ! 😉"
          )}
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;